import { render, staticRenderFns } from "./availableFilBalanceDetail.vue?vue&type=template&id=489b50b4&scoped=true&"
import script from "./availableFilBalanceDetail.vue?vue&type=script&lang=js&"
export * from "./availableFilBalanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./availableFilBalanceDetail.vue?vue&type=style&index=0&id=489b50b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b50b4",
  null
  
)

export default component.exports